import CustomCard from "components/card/CustomCard";
import CustomCardHeader from "components/card/CustomCardHeader";
import PrescriptionList from "./components/PrescriptionList";

const Prescription = () => {
  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <CustomCard>
            <CustomCardHeader contentPosition="none">
              <h2 className="text-2xl text-white">Prescription</h2>
            </CustomCardHeader>
            <PrescriptionList/> 
          </CustomCard>
        </div>
      </div>
    </div>

  )
}

export default Prescription;
